import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import moment from 'moment';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FriendlyDateTime',
  props: {
  date: {
    type: [String, Date],
  },
  placeholder: {
    type: String,
    default: 'never',
  },
},
  setup(__props) {

const props = __props;

const actualDate = computed(() => moment(props.date).format('lll'));
const relativeDate = computed(() => (!props.date ? props.placeholder : moment(props.date).fromNow()));
const isUnknown = computed(() => !props.date && props.placeholder !== 'never');

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (__props.date)
    ? (_openBlock(), _createBlock(_component_n_tooltip, {
        key: 0,
        position: "top",
        text: actualDate.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(relativeDate.value), 1)
        ]),
        _: 1
      }, 8, ["text"]))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass({ 'is-unknown': isUnknown.value })
      }, _toDisplayString(relativeDate.value), 3))
}
}

})